import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react'

interface ChildComponentProps {
    children: React.ReactNode;
    title?: string;
    saveButtonText?: string;
    cancelButtonText?: string;
    openModal?: boolean;
    isValid?: boolean;
    onClose?: React.Dispatch<React.SetStateAction<boolean>>;
    onSave?: () => void;
}

const UserDataModal: React.FC<ChildComponentProps> = ({ children, title, saveButtonText, cancelButtonText, openModal, isValid, onClose, onSave }) => {
    const cancelButtonRef = React.useRef(null)

    return (
        <Transition.Root show={openModal} as={Fragment}>
            <Dialog as="div" className="relative z-10 overflow-hidden" initialFocus={cancelButtonRef} onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-100 w-2xl rounded-2xl overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg !bg-surfacePrimary text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl" style={{ overflow: "hidden" }}>
                                <div className="!bg-surfacePrimary px-4 pb-4 pt-10 sm:px-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h2" className="text-2xl font-semibold leading-6 text-textPrimary">
                                                {title}
                                            </Dialog.Title>
                                            {children}
                                        </div>
                                    </div>
                                </div>
                                <div className="!bg-surfacePrimary px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        onClick={() => onClose(false)}
                                        type="button"
                                        className="flex w-[100px] items-center text-sm hover:cursor-pointer bg-surfaceSecondary p-3 mr-4 text-brand-500 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70 linear justify-center rounded-lg font-bold transition duration-200" >
                                        {cancelButtonText ? cancelButtonText : "Cancel"}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default UserDataModal;